import React from 'react';

const IconGreece = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.2 38.4" {...props}>
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          fill="#0d5eaf"
          d="M3.03 0h49.13c1.67 0 3.03 1.36 3.03 3.03v32.33c0 1.66-1.36 3.02-3.02 3.03H3.02C1.36 38.4 0 37.03 0 35.37V3.03C0 1.36 1.36 0 3.03 0z"
        />
        <path fill="#fff" d="M0 4.27h55.2v4.27H0zm0 8.53h55.2v4.27H0zm0 8.53h55.2v4.27H0zm0 8.54h55.2v4.26H0z" />
        <path fill="#0d5eaf" d="M0 0h21.33v21.33H0z" />
        <path fill="#fff" d="M0 8.53h21.33v4.27H0z" />
        <path fill="#fff" d="M8.53 0h4.27v21.33H8.53z" />
      </g>
    </svg>
  );
};

export default IconGreece;
